import { Node } from 'data/types'
import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import { color } from 'utils'

type Props = {
  onChange: (node: Array<Node>) => void
  options: Array<Node>
}

const StyledSelect = styled(Select)`
  font-size: 0.875rem;

  .bc__placeholder {
    color: ${color('grey400')};
    font-weight: 500;
    & + div {
      width: 100%;
      z-index: 2;
    }
  }

  .bc__indicator-separator {
    display: none;
  }

  .bc__control {
    font-weight: 600;
    line-height: 150%;
    color: ${color('white')};
    background-color: ${color('dark700')};
    border: 1px solid ${color('dark700')};
    border-radius: 8px;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      background-color: ${color('grey100')};
      border: 1px solid transparent;
    }

    &:hover,
    &.bc__control--is-focused,
    &.bc__control--menu-is-open {
      border: 1px solid ${color('primaryMuted')};
    }

    .bc__multi-value {
      background-color: ${color('dark800')};
      color: ${color('white')};

      > .bc__multi-value__label {
        color: ${color('white')};
      }
    }

    .bc__input-container {
      color: white;
    }
  }

  .bc__menu {
    border-radius: 8px;
    box-shadow: 0px 4px 8px ${color('white')};
    background-color: ${color('dark800')};

    .bc__menu-list {
      padding: 0;
    }
  }

  .bc__option {
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 8px;
    transition: background-color 0.3s;

    &.bc__option--is-focused.bc__option--is-selected,
    &.bc__option--is-focused {
      background-color: ${color('dark700')};
    }
  }

  .bc__dropdown-indicator {
    padding-right: 12px;

    &:hover {
      color: ${color('white')};
    }
  }
`

const MultiSelect = ({ onChange, options }: Props) => (
  <StyledSelect
    classNamePrefix='bc'
    isMulti
    options={options.map((opt) => ({ label: opt.text, value: opt.id }))}
    onChange={(items) =>
      onChange(
        options.map((o) => ({
          ...o,
          checked: !!(items as Array<{ value: string }>).find((i) => i.value === o.id)
        }))
      )
    }
  />
)

export default MultiSelect
